import React from "react";
import { ArrowUpRight, Building2, User } from "lucide-react";
import { waLink } from "../lib/site";

const B2B_IMG =
  "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1600&q=80";
const B2C_IMG =
  "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=80";

const empresas = [
  "Capital de giro para PMEs",
  "Expansão e novas unidades",
  "Fluxo de caixa estruturado",
  "Compra de ativos operacionais",
  "Reestruturação financeira",
];

const pf = [
  "Aquisição de imóveis residenciais",
  "Investimento imobiliário",
  "Compra de terrenos e loteamentos",
  "Construção de patrimônio",
  "Liquidez imediata estratégica",
];

const Card = ({ tag, title, list, img, testId, ctaMsg }) => (
  <div
    data-testid={testId}
    className="relative group overflow-hidden border border-white/5 hover:border-[#D4AF37]/40 transition-all duration-700"
  >
    <div className="absolute inset-0">
      <img src={img} alt="" className="w-full h-full object-cover opacity-40 group-hover:opacity-50 group-hover:scale-105 transition-all duration-[1.2s]" />
      <div className="absolute inset-0 bg-gradient-to-br from-[#05070D] via-[#05070D]/85 to-[#05070D]/40" />
    </div>

    <div className="relative p-10 md:p-12 lg:p-14 min-h-[560px] flex flex-col">
      <span className="overline">{tag}</span>
      <h3 className="mt-6 font-serif-ag text-white text-3xl md:text-4xl lg:text-5xl font-light leading-[1.05] tracking-[-0.015em]">
        {title}
      </h3>

      <ul className="mt-10 space-y-4 flex-1">
        {list.map((item, i) => (
          <li key={i} className="flex items-start gap-4 text-[#D6DBE2] font-light">
            <span className="mt-2 w-2 h-px bg-[#D4AF37]" />
            <span className="text-base md:text-lg">{item}</span>
          </li>
        ))}
      </ul>

      <a
        href={waLink(ctaMsg)}
        target="_blank"
        rel="noreferrer"
        data-testid={`${testId}-cta`}
        className="mt-10 inline-flex items-center gap-3 self-start text-xs tracking-[0.22em] uppercase text-[#D4AF37] border-b border-[#D4AF37]/40 pb-2 hover:border-[#D4AF37] transition-colors"
      >
        Solicitar análise <ArrowUpRight size={14} strokeWidth={1.4} />
      </a>
    </div>
  </div>
);

export default function ForWhom() {
  return (
    <section
      id="para-quem"
      data-testid="for-whom-section"
      className="relative bg-[#05070D] py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-16">
          <div className="flex items-center gap-4 mb-6">
            <div className="gold-line" />
            <span className="overline">Para Quem É</span>
          </div>
          <h2 className="font-serif-ag text-white text-4xl md:text-5xl lg:text-[3.5rem] font-light leading-[1.05] tracking-[-0.015em]">
            Soluções desenhadas para{" "}
            <span className="text-[#D4AF37] italic">cada perfil</span>.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          <Card
            testId="for-whom-empresas"
            tag={<span className="inline-flex items-center gap-2"><Building2 size={14} strokeWidth={1.4} /> Empresas</span>}
            title="Capital estratégico para acelerar a empresa"
            list={empresas}
            img={B2B_IMG}
            ctaMsg="Olá, sou empresa e gostaria de uma análise de carta contemplada."
          />
          <Card
            testId="for-whom-pf"
            tag={<span className="inline-flex items-center gap-2"><User size={14} strokeWidth={1.4} /> Pessoa Física</span>}
            title="Liquidez inteligente para conquistar patrimônio"
            list={pf}
            img={B2C_IMG}
            ctaMsg="Olá, sou pessoa física e quero saber mais sobre cartas contempladas."
          />
        </div>
      </div>
    </section>
  );
}
